import { render } from "./AllExternalClinicServices.vue?vue&type=template&id=4d7238e2&scoped=true"
import script from "./AllExternalClinicServices.vue?vue&type=script&lang=js"
export * from "./AllExternalClinicServices.vue?vue&type=script&lang=js"

import "./AllExternalClinicServices.vue?vue&type=style&index=0&id=4d7238e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d7238e2"]])

export default __exports__